import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import backTrack, { VIP_CLOSE_TOAST } from "@/utils/backTrack";
import { sendMapEvent } from "@/utils/analytics";
import { i18n } from "@/i18n/i18n-setup";
import GeneralUtilsHelper from "@/utils/generalUtils";
import headerVideo from "@/views/vipPlanC/headerVideo/headerVideo.vue";
import EventBus from "@/utils/eventBus";
import vipGetReportBtn from "@/components/vipGetReportBtn/vipGetReportBtn.vue";
import { getLang } from "@/api/utils/apiHelper";

var VipPlanF =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipPlanF, _Vue);

  function VipPlanF() {
    var _this;

    _classCallCheck(this, VipPlanF);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipPlanF).apply(this, arguments));
    _this.isSelected = true;
    _this.isShowCloseIcon = false;
    _this.key = "";
    _this.offerId = null;
    _this.vipTime = "month";
    _this.priceText = "";
    _this.queryVipTime = "";
    return _this;
  }

  _createClass(VipPlanF, [{
    key: "clickClose",
    value: function clickClose() {
      var _this2 = this;

      if (!this.isShowCloseIcon) {
        return;
      }

      backTrack.listen({
        key: VIP_CLOSE_TOAST,
        fn: function fn() {
          _this2.hideVipToast();
        }
      });
      this.showCloseToast();
    }
  }, {
    key: "showCloseToast",
    value: function showCloseToast() {
      this.showVipToast({
        confirmFn: this.buyToastVip,
        cancelFn: this.goBack
      });
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(name) {
      sendMapEvent(this.key, {
        key: name
      });
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this3 = this;

      this.key = this.$route.query.key;
      this.queryVipTime = this.vipTime = this.$route.query.vipTime;
      this.changeOfferId();
      var closeIconShowTime = this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_close_btn_delay_show_time : 2000;
      setTimeout(function () {
        _this3.isShowCloseIcon = true;
      }, closeIconShowTime);
    }
  }, {
    key: "hideVipToast",
    value: function hideVipToast() {
      backTrack.destroy(VIP_CLOSE_TOAST);
      EventBus.$emit("vip-toast-show", {
        show: false
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.hideVipToast();
      backTrack.destroy(this.$route.name);
      this.routerGoBack(-1);
    }
  }, {
    key: "selectFreeTrial",
    value: function selectFreeTrial(val) {
      this.isSelected = val;
      GeneralUtilsHelper.vibratePhone(1, [11, 22, -1]);
      this.changeOfferId();
    }
  }, {
    key: "changeOfferId",
    value: function changeOfferId() {
      var _this4 = this;

      if (this.isSelected) {
        this.offerId = null;
      } else {
        var timeStr = this.vipTime === "month" ? "year" : "month";
        this.offerId = _Object$keys(this.offerMap).find(function (item) {
          return _this4.offerMap[item].subscription.period_type.includes(timeStr) && _this4.offerMap[item].free_slogan.toUpperCase() !== "CONTINUE";
        });
      }
    }
  }, {
    key: "buyVIP",
    value: function () {
      var _buyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.sendEvent("click");
                _context.next = 4;
                return this.payVip(this.offerId);

              case 4:
                result = _context.sent;

                if (result) {
                  sendMapEvent("uia_vip_buyway", {
                    key: this.key
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                  this.sendEvent("buy");
                } else {
                  _Toast(this.$t("toast.purchase_failed"));
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function buyVIP() {
        return _buyVIP.apply(this, arguments);
      }

      return buyVIP;
    }()
  }, {
    key: "buyToastVip",
    value: function () {
      var _buyToastVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.sendEvent("click");
                _context2.next = 4;
                return this.payVip();

              case 4:
                result = _context2.sent;

                if (result) {
                  sendMapEvent("uia_vip_buyway", {
                    key: this.key
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                  this.sendEvent("buy");
                } else {
                  _Toast(this.$t("toast.purchase_failed"));
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function buyToastVip() {
        return _buyToastVip.apply(this, arguments);
      }

      return buyToastVip;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      this.initData();
      this.sendEvent("show");
      backTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this5.clickClose();
        }
      });
    }
  }, {
    key: "getText",
    get: function get() {
      return i18n.t("common.button.try_for_free");
    }
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "de" || getLang() === "fr";
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "isItaly",
    get: function get() {
      return getLang() === "it";
    }
  }, {
    key: "getOfferPriceText",
    get: function get() {
      var _this6 = this;

      var timeStr = this.queryVipTime === "month" ? "year" : "month";

      var nowOfferId = _Object$keys(this.offerMap).find(function (item) {
        return _this6.offerMap[item].subscription.period_type.includes(timeStr) && _this6.offerMap[item].free_slogan.toUpperCase() !== "CONTINUE";
      });

      var timeStrUppercase = this.$t("common." + timeStr);
      return timeStrUppercase + ": " + this.priceMap[this.offerMap[nowOfferId].price_id].iap.price + " / " + timeStrUppercase;
    }
  }]);

  return VipPlanF;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], VipPlanF.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], VipPlanF.prototype, "payByIap", void 0);

tslib_1.__decorate([Action(types.SHOW_VIP_TOAST)], VipPlanF.prototype, "showVipToast", void 0);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], VipPlanF.prototype, "hideToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], VipPlanF.prototype, "settingData", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipPlanF.prototype, "payVip", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_SERVICE_LIST)], VipPlanF.prototype, "updateServiceList", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], VipPlanF.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Getter(types.GETTER_OFFER_MAP)], VipPlanF.prototype, "offerMap", void 0);

tslib_1.__decorate([Getter(types.GETTER_PRICE_MAP)], VipPlanF.prototype, "priceMap", void 0);

tslib_1.__decorate([Getter(types.GETTER_OFFER_ID)], VipPlanF.prototype, "globalOfferId", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipPlanF.prototype, "updateResultByName", void 0);

VipPlanF = tslib_1.__decorate([Component({
  components: {
    headerVideo: headerVideo,
    vipGetReportBtn: vipGetReportBtn
  }
})], VipPlanF);
export default VipPlanF;